import { getAuthorizationHeader } from "@brandclub/common-ui";
import { SurveyResponse } from "../../../types/misc";
import axios from "../../../utils/axios";

export interface SubmitSurveyForRequest {
  responses: (SurveyResponse | null)[];
  campaignId: string;
  surveyId: string;
}

type SurveyReward<T extends Record<string, any> = {}> = {
  rewardId: string;
  userId: string;
  rewardAmount: number;
  rewardCurrency: string;
  rewardStatus: "unlocked" | "locked" | "expired";
  extendedAttributes?: T;
};

export const submitSurveyForReward = async (req: SubmitSurveyForRequest) => {
  return await axios.post<{
    message?: string;
    valid?: boolean;
    success?: boolean;
    reward?: SurveyReward;
    errors?: {
      question: string;
      response: string;
      isValid: boolean;
    }[];
  }>("/survey/submitSurveyV2", req, {
    headers: {
      ...(await getAuthorizationHeader()),
    },
  });
};

export const canSubmitSurveyResponse = async (): Promise<boolean> => {
  return (
    await axios.post(
      "/survey/canSubmitSurveyV2",
      {},
      {
        headers: {
          ...(await getAuthorizationHeader()),
        },
      }
    )
  )?.data;
};
